import { Field, Float, InputType, ObjectType } from 'type-graphql'

import { modelOptions, Prop } from '@typegoose/typegoose'
import { Company, CompanyTypeEnum } from '@ztechapps/common.contract'

@ObjectType()
@InputType('SchoolInput')
@modelOptions({ schemaOptions: { timestamps: true, strict: false, collection: 'companies' } }) //we need to define the collection name here, as the companies, because it will use that collection
export class School extends Company {
  @Field(() => String)
  @Prop({ type: String, default: CompanyTypeEnum.school })
  declare type: CompanyTypeEnum

  /**
   * The pool's current balance, resolver-only (no `@Prop`) — the figure is already persisted as
   * `CreditAccount.balance`, so a second stored copy here would need updating on every debit,
   * grant, purchase and join. Batch-attached by whichever read serves it.
   */
  @Field(() => Float, { nullable: true })
  poolBalance?: number
}
